import React from 'react';

class Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            url: "https://www.instagram.com/p/Bp-cijMhkiA/"
        }
        this.onSubmit = this
            .onSubmit
            .bind(this);
    }
    componentDidMount() {

        function getQueryStringValue(key) {
            return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
        }

        // Would write the value of the QueryString-variable called name to the console
        if (getQueryStringValue("url")) {
            this.setState({url: getQueryStringValue("url")});
            this.props.fetchURL(getQueryStringValue("url"));
        }
    }

    onSubmit(event) {
        event.preventDefault();
        if (this.state.url !== undefined) {
            this.props.fetchURL(this.state.url);
        }
    }
    render() {

        return (
            <React.Fragment>
                <form submit="/" action="" onSubmit={(event) => this.onSubmit(event)}>
                    <input
                        value={this.state.url}
                        type="url"
                        onChange={(event) => this.setState({url: event.target.value})}
                        className="input-url"/>
                    <input type="submit" className="submitBtn" value="Download Image/Video"></input>
                </form>

            </React.Fragment>
        )
    }

};
export default Form;
